import React, { useEffect, useState } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Link, } from "react-router-dom";
import { Form, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { translateAuto } from "../../../../_metronic/_helpers/AtHelper";

export default function ResetPassword(props) {

    var url2 = window.location.search;
    let param = url2?.replace("?code=", "");
    let code = param?.split("&")[0];
    var emailsplit = param?.split("&")[1];
    var email = emailsplit?.replace("email=", "");
    const history = useHistory();
    const [accountverified, setaccountverified] = useState(false);
    const [tab, settab] = useState([0, 0, 0, 0]);
    const [showpassword, setShowpassword] = useState();
    const [verpaassword, setverpaassword] = useState(false);
    const [isLoadingAuth, setisLoadingAuth] = useState(false);
    const [initRESETOBJ, setinitRESETOBJ] = useState({
        "Email": email,
        "Token": code,
        "Password": "",
        "ConfirmPassword": ""
    })
    const { t } = useTranslation();
    useEffect(() => {
        if (code) {
            setaccountverified(true)
        }


    }, [code])

    function sendCodeFunction() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var raw = JSON.stringify(initRESETOBJ);
        setisLoadingAuth(true);
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        fetch(`${window.$apiurl}/api/Account/ResetPassword`, requestOptions)
            .then(async (response) => {
                const statusCode = await response.status;
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    return response.json().then((data) => [statusCode, data]);
                } else {
                    return response.text().then((text) => [statusCode, { Message: "" }]);
                }
            })
            .then((result) => {
                if (result[0] === 200) {
                    setaccountverified(true);
                    history.push("/logout");
                } else {
                    if (
                        result[1].ModelState !== null &&
                        result[1].ModelState !== undefined &&
                        result[1].ModelState !== ""
                    ) {
                        let modelState = result[1].ModelState;
                        if (modelState)
                            Object.keys(modelState).forEach(function (k) {
                                modelState[k].forEach((element) => {
                                    Swal.fire(translateAuto("Error"), translateAuto(element), "error");
                                });
                            });
                    } else if (
                        result[1].Message !== null &&
                        result[1].Message !== undefined &&
                        result[1].Message !== ""
                    ) {
                        Swal.fire(translateAuto("Error"), translateAuto(result[1].Message) , "error");
                    } else if (
                        result[1].error_description !== null &&
                        result[1].error_description !== undefined &&
                        result[1].error_description !== ""
                    ) {
                        Swal.fire(translateAuto("Error"), translateAuto(result[1].error_description) , "error");
                    } else {
                        Swal.fire(translateAuto("Error"), translateAuto("Bad_request"));
                    }
                }
                setisLoadingAuth(false);
            })
            .catch((error) => {
                Swal.fire(translateAuto("Error"), translateAuto(error), "error");
                setisLoadingAuth(false);
            });

    }

    return (


        <>{!accountverified ? <><div className="login login-3 login-signin-on d-flex flex-row-fluid" id="">
            <div className="d-flex flex-center bgi-size-cover bgi-no-repeat flex-row-fluid" style={{ backgroundImage: 'url(/media/bg/bg-3.jpg)' }}>
                <div className="col-xl-6 col-lg-6 col-md-10 col-12  p-7 position-relative overflow-hidden">
                    {/*begin::Login Header*/}
                    <div className="d-flex flex-center mb-15">
                        <a href={() => false}>
                            <SVG src={toAbsoluteUrl("/media/svg/logos/Full-Color_-RGB_Vertical.svg")} />
                        </a>
                    </div>
                    {/*end::Login Header*/}
                    {/*begin::Login Sign in form*/}
                    <div className="card card-custom bg-transparent shadow-none">
                        <div className="card-header card-header-tabs-line pl-0">
                            <div className="card-body">
                                <div className="login-signin">
                                    <div className="text-center">
                                        <h2 className="font-size-h1 mb-5 font-weight-bolder">{t('Verify_Your_Email')}</h2>
                                        <div className="font-size-h3 text-muted font-weight-bold">
                                            We have sent an email from {" "}
                                            <a href={() => false()} className="text-primary text-decoration-none font-weight-bolder line-height-lg my-3">
                                                support@mail.empowerdl.com</a><br />
                                            {t('verify_email')}
                                        </div>
                                        <div className="text-center my-10">
                                            <Link to="/auth/login" className="btn btn-lg btn-primary font-weight-bolder">{t('Log_In')}</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*end::Login Sign in form*/}
                        </div>
                    </div>
                </div>
            </div>
            {/*end::Login*/}
        </div>
        </>
            : <>
                <div className="login login-3 login-signin-on d-flex flex-row-fluid" id="">
                    <div className="d-flex flex-center bgi-size-cover bgi-no-repeat flex-row-fluid" style={{ backgroundImage: 'url(/media/bg/bg-3.jpg)' }}>
                        <div className="col-xl-5 col-lg-5 col-md-10 col-12  p-7 position-relative overflow-hidden">
                            {/*begin::Login Header*/}
                            <div className="d-flex flex-center mb-15">
                                <a href={() => false}>
                                    <SVG src={toAbsoluteUrl("/media/svg/logos/Full-Color_-RGB_Vertical.svg")} />
                                </a>
                            </div>
                            {/*end::Login Header*/}
                            {/*begin::Login Sign in form*/}
                            <div className="card card-custom">
                                <div className="card-header card-header-tabs-line">
                                    <div className="card-body">
                                        <div className="login-signin">
                                            <div className="mb-20 text-center">
                                                <h3 className="font-size-h1">{t("Setup_New_Password")}</h3>
                                                <div className="text-muted font-weight-bold">
                                                    {t("Already_have_reset_your_password")} ? <span className="text-primary"><Link to="/aut/login">{t("Sign_in_here")}</Link></span>
                                                </div>
                                            </div>



                                            <Form.Group controlId="formHorizontalEmail">
                                                <Form.Label>
                                                    {t("Password")}
                                                </Form.Label>
                                                <div className="mb-1">
                                                    {/*begin::Input wrapper*/}
                                                    <div className="position-relative mb-3">
                                                        <input
                                                            onChange={(e) => {
                                                                let objt = { ...initRESETOBJ };
                                                                objt.Password = e.target.value;
                                                                setinitRESETOBJ(objt);
                                                                settab([0, 0, 0, 0]);
                                                                let obj = [0, 0, 0, 0];


                                                                if (e.target.value.length > 7) {
                                                                    obj[0] = 1;
                                                                }
                                                                if (/[A-Z]/.test(e.target.value)) {
                                                                    obj[1] = 1;
                                                                }

                                                                if (/[0-9]/.test(e.target.value)) {
                                                                    obj[2] = 1;
                                                                }
                                                                if (/[!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?]/.test(e.target.value)) {
                                                                    obj[3] = 1;
                                                                }

                                                                settab(obj);
                                                            }} className="form-control form-control-lg form-control-solid" type={showpassword ? "text" : "password"} placeholder name="password" autoComplete="off" />
                                                        <div className="position-absolute translate-middle-c top-50 end-0 mr-3">
                                                            <span className="svg-icon svg-icon-2hx" onClick={() => setShowpassword(showpassword ? false : true)}>
                                                                <img src={toAbsoluteUrl(showpassword ? "/media/svg/icons/General/Visible.svg" : "/media/svg/icons/General/Hidden.svg")} alt="" className="h-25px" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {/*end::Input wrapper*/}
                                                    {/*begin::Meter*/}
                                                    <div className="d-flex align-items-center mb-3" data-kt-password-meter-control="highlight">
                                                        <div className={`${tab.filter(x => x === 1).length > 0 ? "flex-grow-1 bg-secondary bg-success rounded h-5px mr-2" : "flex-grow-1 bg-secondary bg-active-success rounded h-5px mr-2"}`} />
                                                        <div className={`${tab.filter(x => x === 1).length > 1 ? "flex-grow-1 bg-secondary bg-success rounded h-5px mr-2" : "flex-grow-1 bg-secondary bg-active-success rounded h-5px mr-2"}`} />
                                                        <div className={`${tab.filter(x => x === 1).length > 2 ? "flex-grow-1 bg-secondary bg-success rounded h-5px mr-2" : "flex-grow-1 bg-secondary bg-active-success rounded h-5px mr-2"}`} />
                                                        <div className={`${tab.filter(x => x === 1).length > 3 ? "flex-grow-1 bg-secondary bg-success rounded h-5px mr-2" : "flex-grow-1 bg-secondary bg-active-success rounded h-5px mr-2"}`} />
                                                    </div>
                                                    {verpaassword ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                data-field="width"
                                                                data-validator="digits"
                                                                className="fv-help-block text-danger"
                                                            >
                                                                {t("Please_check_your_Password")}
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                    {/*end::Meter*/}
                                                </div>
                                            </Form.Group>
                                            <Form.Group controlId="formHorizontalEmail">
                                                <Form.Label>
                                                    {t("Confirm_Password")}
                                                </Form.Label>
                                                <div className="mb-1">
                                                    {/*begin::Input wrapper*/}
                                                    <input onChange={(e) => {
                                                        let objt = { ...initRESETOBJ };
                                                        objt.ConfirmPassword = e.target.value;
                                                        setinitRESETOBJ(objt);
                                                    }} className={`form-control form-control-lg form-control-solid  ${initRESETOBJ.ConfirmPassword !== "" && initRESETOBJ.Password !== initRESETOBJ.ConfirmPassword ? "border border-danger" : ""}`} type={showpassword ? "text" : "password"} name="password ConfirmPassword" autoComplete="off" />
                                                </div>
                                            </Form.Group>
                                            <div className="form-group d-flex flex-wrap flex-center">
                                                <button
                                                    disabled={isLoadingAuth}
                                                    className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                                                    onClick={() => {
                                                        if (tab.filter((x) => x === 1).length < 4 && initRESETOBJ.Password !== "") {
                                                            setverpaassword(true);
                                                            return;
                                                        }
                                                        if (initRESETOBJ.Password !== initRESETOBJ.ConfirmPassword) {
                                                            return;
                                                        }
                                                        sendCodeFunction()
                                                    }}
                                                >
                                                    {t("Submit")}
                                                    {isLoadingAuth && (
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                        />)}
                                                </button>
                                                <Link to="/auth">
                                                    <button
                                                        type="button"
                                                        id="kt_login_forgot_cancel"
                                                        className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                                                    >
                                                        {t("Cancel")}
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*end::Login Sign in form*/}

                            </div>
                        </div>
                    </div>
                    {/*end::Login*/}
                </div>
            </>
        }</>


    )
}
